import OutlinedButton from './outlined-button-styles'

export default OutlinedButton
